import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { FileOpenOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { Card, Space, Table, Tooltip, Select, Button, Row, Col, message } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import generatePDFReport from "FileGenerator/AdminFileGenerator/generatePDFReport";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

function OfferLetter() {
  const [data, setData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("All Departments");
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_Base_URL;
  const navigate = useNavigate();

  useEffect(() => {
     const fetchDepartments = async () => {
    try {
      const res = await axiosInstance.get(API.department.getList);
      setSelectedDepartment("all");
      setDepartments(res.data || []);
      fetchData();
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
    fetchDepartments();
  }, []);

  
  //  Fetch Offer Letter Report data
  const fetchData = async (departmentId = null)  => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(API.reports.getOfferLetterReport(departmentId));

      if (Array.isArray(response.data)) {
        setData(
          response.data.map((item) => ({
            key: item.id,
            name: `${item.firstName} ${item.lastName}`,
            email: item.email,
            offerLetter: item.offerLetter,
            signedOfferLetter: item.signedOfferLetter,
            signedOfferLetterDate: item.signedOfferLetterDate
  ? new Date(item.signedOfferLetterDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).replace(",", "").replace(/ /g, "-")
  : "N/A",
            isSignedByEmployee: item.isSignedByEmployee ? "Yes" : "No",
          }))
        );
      } else {
        message.warning("No offer letter records found.");
      }
    } catch (error) {
      console.error("Error fetching offer letter data:", error);
      message.error("Failed to load offer letter report.");
    } finally {
      setLoading(false);
    }
  };

  

  //  Preview PDF in browser
  const handlePdfPreview = (fileUrl) => {
    window.open(`${apiUrl}/${fileUrl}`, "_blank");
  };

  //  Generate Offer Letter Report PDF
  const handleDownloadPDF = () => {
    if (!data.length) {
      message.warning("No data available to generate report.");
      return;
    }

    generatePDFReport(data, {
      title: "Offer Letter Report",
      department: selectedDepartment,
      reportDate: new Date().toLocaleDateString(),
      columns: ["Employee Name", "Email", "Offer Letter", "Signed By Employee", "Signed Date"],
      rowMapper: (item) => [
        item.name,
        item.email,
        item.offerLetter ? "Available" : "Not Uploaded",
        item.isSignedByEmployee,
        item.signedOfferLetterDate,
      ],
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => (
        <Tooltip title={email}>{email?.length > 13 ? `${email.slice(0, 13)}...` : email}</Tooltip>
      ),
    },
    {
      title: "Offer Letter",
      dataIndex: "offerLetter",
      key: "offerLetter",
      render: (url) =>
        url ? (
          <FileOpenOutlined
            onClick={() => handlePdfPreview(url)}
            style={{ cursor: "pointer", color: "#1677ff" }}
          />
        ) : (
          "N/A"
        ),
    },
    {
      title: "Signed by Employee",
      dataIndex: "isSignedByEmployee",
      key: "isSignedByEmployee",
    },
    {
      title: "Signed Date",
      dataIndex: "signedOfferLetterDate",
      key: "signedOfferLetterDate",
    },
    {
      title: "Signed Letter",
      dataIndex: "signedOfferLetter",
      key: "signedOfferLetter",
      render: (url) =>
        url ? (
          <FileOpenOutlined
            onClick={() => handlePdfPreview(url)}
            style={{ cursor: "pointer", color: "#1677ff" }}
          />
        ) : (
          "N/A"
        ),
    },
  ];

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card
            title="Offer Letters"
            className="card-professional"
            extra={<Button onClick={() => navigate(-1)}>Back</Button>}
          >
            {/*  Filter and Download Controls */}
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
              <Col>
                <Select
  allowClear
  value={selectedDepartment ?? "all"}
  style={{ width: 250 }}
  onChange={(value) => {
    setSelectedDepartment(value);
    fetchData(value === "all" ? null : value); // send null for all departments
  }}
>
  <Option value="all">All Departments</Option>
  {departments.map((dept) => (
    <Option key={dept.id} value={dept.id}>
      {dept.name}
    </Option>
  ))}
</Select>
              </Col>

              <Col>
                <Button className="btn-primary" icon={<FileDownloadOutlined />} onClick={handleDownloadPDF}>
                  Download PDF
                </Button>
              </Col>
            </Row>

            {/* 📊 Data Table */}
            <Table
              bordered
              loading={loading}
              className="custom-table"
              dataSource={data}
              columns={columns}
              pagination={{ pageSize: 10 }}
            />
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default OfferLetter;
